class IdHelper {
  static formatCollectId(id: number) {
    return `${id}`.padStart(3, '0');
  }

  static formatExclusionId(id: number) {
    return `${id}`.padStart(6, '0');
  }

  static formatContactId(id: number | string): string {
    if (typeof id === 'string') {
      return id;
    }
    return `${id}`.padStart(6, '0');
  }
}

export { IdHelper };
